import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { VerticaTableDataset } from 'app/model/dataset/vertica.dataset';
import { VerticaLinkedService } from 'app/model/linkedservice/vertica.linkedservice';
import { format } from 'app/shared/utils/string.util';

export const verticaTableMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(VerticaTableDataset).name,
    displayName: stringResources.Vertica_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(VerticaLinkedService).name],
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-vertica'
    },
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.VersionLabel.toLocaleLowerCase()
    ),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-vertica',
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database'],
    copyJob: {
        multipleQuery: true
    }
};
